import HelmetTags from "../../../../MainComponents/HelmetTags";
import { useMemo, useState } from "react";
import useTable from "../../../../MainComponents/Hooks/useTable";

const LateStudents = () => {
  const [academiclevel, setAcademicLevel] = useState(1);
  const [academicType, setAcademicType] = useState("scientific");
  const [systemType, setSystemType] = useState("hand_by_hand");

  const lateStudentsParams = useMemo(() => {
    if (academiclevel === 1) return "1/null";
    if (academiclevel === 3) {
      if (academicType === "scientific") {
        return `${academiclevel}/${academicType}/${systemType}`;
      }
      return `${academiclevel}/${academicType}`;
    }
    return `${academiclevel}/null`;
  }, [academiclevel, academicType, systemType]);

  const viewAllLateStudentsTable = useTable(
    "viewAllLateStudents",
    "",
    "",
    academiclevel,
    `${academicType}-${systemType}`,
    lateStudentsParams,
    "",
    "",
    "",
    "",
    "",
    true
  );

  return (
    <section className="dark:bg-dark dark:text-light flex h-full w-full flex-col items-start overflow-y-auto px-10 py-10 sm:px-4 md:items-center">
      <HelmetTags title="Late Students | Mr.Mohamed Salama" />
      <h2 className="text-start text-2xl font-bold">Late Students</h2>

      <div className="filters relative my-4 flex w-1/2 items-center justify-between text-center transition-all duration-200 ease-in-out md:w-full md:flex-col md:px-6">
        <button
          onClick={() => setAcademicLevel(1)}
          className={`z-10 w-1/3 py-2 text-base font-semibold md:w-full ${
            academiclevel === 1 && "bg-green rounded-md duration-300"
          }`}
        >
          1st sec
        </button>
        <button
          onClick={() => setAcademicLevel(2)}
          className={`z-10 w-1/3 py-2 text-base font-semibold md:w-full ${
            academiclevel === 2 && "bg-green rounded-md duration-300"
          }`}
        >
          2nd sec
        </button>
        <button
          onClick={() => setAcademicLevel(3)}
          className={`z-10 w-1/3 py-2 text-base font-semibold md:w-full ${
            academiclevel === 3 && "bg-green rounded-md duration-300"
          }`}
        >
          3rd sec
        </button>
      </div>

      {+academiclevel === 3 && (
        <div className="mt-10 flex w-full flex-col items-center gap-4">
          <div className="filters-container bg-light-gray flex w-full justify-center dark:bg-[#121a35]">
            <div className="filters relative flex h-12 w-[800px] items-center justify-between transition-all duration-200 ease-in-out amd-hero:w-28 amd-hero:flex-col">
              <div
                onClick={() => setAcademicType("scientific")}
                className={`calculus flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                  academicType === "scientific" ? "bg-green" : ""
                }`}
              >
                Scientific
              </div>

              <div
                onClick={() => setAcademicType("literary")}
                className={`Algebra flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                  academicType === "literary" ? "bg-green" : ""
                }`}
              >
                Literary
              </div>
            </div>
          </div>

          {academicType === "scientific" && (
            <div className="filters-container bg-light-gray flex w-full justify-center dark:bg-[#121a35]">
              <div className="filters relative flex h-12 w-[800px] items-center justify-between transition-all duration-200 ease-in-out amd-hero:w-28 amd-hero:flex-col">
                <div
                  onClick={() => setSystemType("hand_by_hand")}
                  className={`flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                    systemType === "hand_by_hand" ? "bg-green" : ""
                  }`}
                >
                  ايد بايد
                </div>
                <div
                  onClick={() => setSystemType("normal")}
                  className={`flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                    systemType === "normal" ? "bg-green" : ""
                  }`}
                >
                  النظام العادي
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="flex w-full items-start justify-center gap-20 lg:flex-col lg:items-center lg:justify-star">
        <div className="h-fit w-full">{viewAllLateStudentsTable}</div>
      </div>
    </section>
  );
};

export default LateStudents;
